export default "__VITE_ASSET__Q6Qfx_gb__"